"use client";

import { useEffect } from "react";

interface Props {
    lang: string;
}

export default function HtmlLanguage({
    lang,
}: Props) {

    useEffect(() => {

        document.documentElement.lang = lang;

        document.documentElement.dir =
            lang === "ar"
                ? "rtl"
                : "ltr";

    }, [lang]);

    return null;
}